import React from 'react'
import { useCallback } from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import { postData } from '../services/profileService'
import { isTokenInvalidOrAbsent } from 'src/views/pages/login/ProtectedRoute'
import { appInstallationId, commonHeadersWeb } from '../services'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { getProfileData } from 'src/reducers/profileData/services/profileData'
import { REDUX_STATUS_LOADING } from '../constants'
import { selectProfileData, setProfileData } from 'src/reducers/profileData/profileDataReducer'
import { normalizeProfileData } from 'src/reducers/profileData/normalizeProfileData'
import { getAllRolesInBoolean } from 'src/mentor/layout/utils'
import { rememberLastLoginHintFromProfile } from 'src/shared/auth/lastLoginHint'

export const ProfileContext = React.createContext()

export const ProfileContextProvider = ({ children }) => {
  // const [profileData, setProfileData] = useState(null)
  const dispatch = useDispatch()
  const [authToken, setAuthToken] = useState()
  // Removed FCM dependency - FCM token submission is now independent and non-blocking
  // const [loading, setLoading] = useState(false)

  const profileDataState = useSelector(selectProfileData)
  const profileData = profileDataState?.data
  const loading = profileDataState?.status === REDUX_STATUS_LOADING
  const isReadOnlyRescricted = getAllRolesInBoolean().isReadOnlyRescricted

  const navigate = useNavigate()

  // const fetchProfileData = async () => {
  //   setLoading(true)
  //   try {
  //     const resp = await getData('/api/secure/user/profile')
  //     if (resp?.status === 200) {
  //       setProfileData(resp.data)
  //       localStorage.setItem('authorities', JSON.stringify(resp?.data?.authorities))
  //     } else if (shouldLogOutBasedOnHttpResponseStatus(resp?.response?.status)) {
  //       const redirectURI = encodeURIComponent(window.location.href)
  //       if (window.location.pathname.split('/').includes('chamber-screen-home')) {
  //         logoutHandler(['ROLE_CA_CONFIG', 'ROLE_SCREEN_CONFIG'], [])
  //       } else {
  //         logoutHandler([], ['autoNavigatedToEmrOnceInSession'])
  //       }
  //       navigate(`/?redirect=${redirectURI}`)
  //     }
  //   } catch (error) {
  //     // Handle any errors from the data fetching here
  //   }
  //   setLoading(false)
  // }

  // useEffect(() => {
  //   const token = localStorage.getItem('token')
  //   if (isTokenInvalidOrAbsent(token)) {
  //     setProfileData(null)
  //   } else {
  //     fetchProfileData()
  //   }
  // }, [authToken])

  const fetchProfileData = useCallback(async ({ _forceRefresh = false } = {}) => {
    dispatch(getProfileData({ navigate, _forceRefresh }))
  }, [dispatch, navigate])

  useEffect(() => {
    const token = localStorage.getItem('token')
    // Skip fetch if profileData already exists (prevent unnecessary reload)
    // getProfileData thunk already checks Redux store, but this prevents unnecessary dispatch calls
    if (!isTokenInvalidOrAbsent(token) && navigate && dispatch && !profileData) {
      fetchProfileData()
    }
  }, [authToken, dispatch, fetchProfileData, navigate, profileData]) // Add profileData to deps to prevent unnecessary calls

  // FCM device token submission - independent and non-blocking
  // Gets FCM token from localStorage (set by FCMProvider) or waits for it
  useEffect(() => {
    ;(async () => {
      // Get FCM token from localStorage (FCMProvider stores it there)
      // This allows device registration to happen independently of FCMProvider rendering
      const fcmToken = localStorage.getItem('FCMToken')
      if (fcmToken && profileData) {
        await informUserDeviceToServer(fcmToken, profileData)
      }
    })()
  }, [profileData]) // Only depends on profileData - FCM token comes from localStorage

  useEffect(() => {
    if (profileData) {
      rememberLastLoginHintFromProfile(profileData)
    }
  }, [profileData])

  const handleChangeStorage = useCallback(() => {
    const storageAuthToken = localStorage.getItem('token')
    if (storageAuthToken !== authToken) {
      setAuthToken(storageAuthToken)
    }
  }, [authToken])

  useEffect(() => {
    handleChangeStorage() //call this when someone reloads the page or this context is mounted

    window.addEventListener('storage', handleChangeStorage)
    return () => window.removeEventListener('storage', handleChangeStorage)
  }, [handleChangeStorage])

  console.log({ profileData, profileDataState })

  const handleSetProfileData = useCallback((data) => {
    const normalizedProfileData = normalizeProfileData(data)

    // Update Redux store with new profile data
    dispatch(setProfileData(normalizedProfileData))

    // Update authorities in localStorage (critical for role-based access control)
    if (normalizedProfileData?.authorities) {
      localStorage.setItem('authorities', JSON.stringify(normalizedProfileData.authorities))
    }
  }, [dispatch])

  return (
    <ProfileContext.Provider
      value={{
        profileData,
        setProfileData: handleSetProfileData,
        authToken,
        refreshProfileData: fetchProfileData,
        profileDataLoading: loading,
      }}
    >
      {isReadOnlyRescricted && (
        <div
          style={{
            width: '100vw',
            background: 'red',
            color: 'white',
            position: 'fixed',
            zIndex: 9999,
          }}
        >
          You are in read only mode.
        </div>
      )}
      {children}
    </ProfileContext.Provider>
  )
}

async function informUserDeviceToServer(fcmToken, profileData) {
  // if fcm token was not submitted before
  if (!localStorage.getItem('submittedFCMTokenForThisUser')) {
    const body = {
      deviceId: appInstallationId,
      userId: profileData?.userId,
      platformId: 0,
      pushRegId: fcmToken,
      imei: '',
      createTime: new Date().toISOString(),
      modifiedTime: new Date().toISOString(),
      appPackage: commonHeadersWeb['ef-app-package'],
    }
    const resp = await postData('/api/secure/user/device', body)
    if (resp?.status === 200) {
      localStorage.setItem('submittedFCMTokenForThisUser', true)
    }
  }
}
